import { COMPANY } from './company'
import { ROUTES } from './routes'
import type { OfferGroup } from './content-pages'

export const ABOUT_PAGE = {
  eyebrow: 'About us',
  title: 'Welcome to Maaliondoor',
  intro: [
    `${COMPANY.legalName} is a technology-driven flowers, plants, corporate gifting, and event decoration company committed to making every celebration memorable. We provide innovative, reliable, and customized gifting solutions for individuals, businesses, and organizations across India.`,
    'Our mission is to simplify gifting and decoration by connecting customers with trusted local florists, plant nurseries, and gifting partners while delivering premium quality products with exceptional service.',
  ],
  whoWeAre: {
    title: 'Who we are',
    body: 'Maaliondoor is a one-stop destination for flowers, plants, corporate gifting, plant rental, landscaping, welcome kits, event decoration, and festival decoration. We combine technology with a strong local vendor network to offer high-quality products, competitive pricing, and seamless customer experiences.',
    extra:
      "Whether you're celebrating a birthday, organizing a corporate event, decorating an office, or sending a thoughtful gift, Maaliondoor delivers solutions tailored to your needs.",
  },
  vision: {
    title: 'Our vision',
    body: "To become India's most trusted and technology-driven platform for flowers, plants, corporate gifting, and event decoration by empowering local florists, promoting sustainability, and creating exceptional customer experiences.",
  },
  mission: {
    title: 'Our mission',
    items: [
      'Deliver premium-quality flowers, plants, and gifts.',
      'Support local florists and plant growers through technology.',
      'Make gifting affordable, convenient, and memorable.',
      'Provide innovative corporate gifting and decoration solutions.',
      'Promote sustainable and eco-friendly gifting across India.',
    ],
  },
  offersTitle: 'What we offer',
  offers: [
    {
      title: 'Fresh flowers',
      items: [
        'Premium flower bouquets',
        'Basket arrangements',
        'Luxury floral boxes',
        'Wedding flowers',
        'Car decorations',
        'Sympathy flowers',
        'Personalized floral gifts',
      ],
    },
    {
      title: 'Plants & green solutions',
      items: [
        'Indoor plants',
        'Outdoor plants',
        'Air purifying plants',
        'Plant gifting',
        'Plant rental',
        'Office plants',
        'Landscaping services',
        'Plant maintenance',
      ],
    },
    {
      title: 'Corporate gifting',
      items: [
        'Employee welcome kits',
        'Joining kits',
        'Festive gifts',
        'Diwali hampers',
        'Appreciation gifts',
        'Client gifts',
        'Conference kits',
        'Promotional gifts',
        'Customized branding',
      ],
    },
    {
      title: 'Event decoration',
      items: [
        'Office decoration',
        'Corporate events',
        'Festival decoration',
        'Independence Day decoration',
        'Republic Day decoration',
        'Diwali decoration',
        'Inauguration decoration',
        'Product launch events',
      ],
    },
    {
      title: 'Business solutions',
      items: [
        'Corporate flower subscription',
        'Reception floral arrangement',
        'Workspace decoration',
        'Office greenery',
        'AMC for plants',
        'Customized corporate solutions',
      ],
    },
  ] satisfies OfferGroup[],
  whyTitle: 'Why choose Maaliondoor?',
  whyItems: [
    'Premium quality products',
    'Fresh flowers direct from local florists',
    'Trusted vendor network',
    'Customized gifting solutions',
    'Corporate & bulk order expertise',
    'Professional event decoration',
    'Affordable pricing',
    'Transparent billing',
    'Dedicated customer support',
    'Sustainable & eco-friendly solutions',
    'Timely delivery',
    'Personalized service',
  ],
  industriesTitle: 'Industries we serve',
  industries: [
    'Corporate offices',
    'IT companies',
    'Real estate developers',
    'Hospitals',
    'Hotels & restaurants',
    'Educational institutions',
    'Government organizations',
    'Event management companies',
    'Startups & SMEs',
    'Retail businesses',
    'Banking & financial institutions',
  ],
  valuesTitle: 'Our core values',
  values: [
    'Customer first',
    'Quality excellence',
    'Transparency',
    'Innovation',
    'Sustainability',
    'Integrity',
    'Reliability',
    'Professionalism',
  ],
  commitment: {
    title: 'Our commitment',
    body: 'We are committed to delivering premium products, professional services, and memorable experiences. Every bouquet, plant, gift, and decoration project is executed with attention to detail, ensuring the highest standards of quality and customer satisfaction.',
  },
  sustainability: {
    title: 'Sustainability',
    body: 'At Maaliondoor, we believe in responsible business practices by supporting local florists, encouraging plant gifting, reducing waste, and promoting environmentally friendly gifting solutions that contribute to a greener future.',
  },
  promiseTitle: 'Our promise',
  promiseItems: [
    'Fresh & premium products',
    'Customized solutions',
    'Professional execution',
    'Transparent pricing',
    'Reliable service',
    'Customer satisfaction',
    'End-to-end project management',
  ],
  companyTitle: 'Company information',
  companyFacts: [
    { label: 'Company name', value: COMPANY.legalName },
    { label: 'Brand name', value: COMPANY.brandName },
    { label: 'Tagline', value: COMPANY.tagline },
    { label: 'Registered office', value: COMPANY.address },
    { label: 'GSTIN', value: COMPANY.gstin },
    { label: 'Website', value: COMPANY.websiteLabel, href: COMPANY.websiteHref },
    { label: 'Email', value: COMPANY.email, href: COMPANY.emailHref },
    { label: 'Customer support', value: COMPANY.phoneDisplay, href: COMPANY.phoneHref },
  ],
  closingTitle: "Let's create memorable moments together",
  closing:
    'From heartfelt personal gifts to large-scale corporate events, Maaliondoor is your trusted partner for flowers, plants, gifting, and decoration. We combine creativity, quality, and technology to deliver experiences that leave a lasting impression.',
  ctaLabel: 'Talk to our team',
  ctaTo: ROUTES.contact,
} as const
